/* ---------------------------------------- [START] 簡單的節流函數 */
// https://www.cnblogs.com/coco1s/p/5499469.html
function throttle(func, wait, mustRun) {
	var timeout;
	var startTime = new Date();

	return function () {
		var context = this;
		var args = arguments;
		var curTime = new Date();

		if (timeout !== undefined) {
			if (window.requestTimeout !== undefined) clearRequestTimeout(timeout);
			else clearTimeout(timeout);
		}
		// 如果達到了規定的觸發時間間隔，觸發 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 沒達到觸發間隔，重新設定定時器
		} else {
			if (window.requestTimeout !== undefined) timeout = requestTimeout(func, wait);
			else timeout = setTimeout(func, wait);
		}
	};
}
/* ---------------------------------------- [END] 簡單的節流函數 */

(function(window, document) {
	/* ----------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	// const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	// let ws = 0;
	// function getScrollTop(target = window) {
	// 	return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	// }
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		// ws = getScrollTop();
	}
	window.addEventListener('load', getWinSet);
	window.addEventListener('resize', throttle(getWinSet, 50, 100));
	/* ----------------------------------- [END] Windows Setting */

	/* ----------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	var isMobile = false;
	var isTablet = false;
	var isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};
	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ----------------------------------- [END] 取得裝置判斷 */

	/* ---------------------------------------- [START] Click Blur  */
	const checkboxs = document.querySelectorAll('.js-compare-checkbox');
	checkboxs.forEach((item) => {
		item.addEventListener('click', function() {
			item.blur();
		});
	});
	/* ---------------------------------------- [END] Click Blur  */

	/* ---------------------------------------- [START] 選單 - 展開收合  */
	const compareMenu = document.querySelector('#compare-menu');
	const compareClassOpen = 'is-open';
	const compareClassCollapse = 'is-collapse';
	const compareClassOpenHtml = 'compare-open';

	const compareStorageKey = 'compareMenuOpen'; // 記錄使用者紀錄

	let open = window.innerWidth >= 1024; // （預設）狀態
	let swiper = null;

	function compareMenuOpen() {
		// 關閉Scroll
		if (isMobile && ww < 1024) {
			window.docDisableScroll && docDisableScroll();
		}

		open = true;
		compareMenu.classList.add(compareClassOpen);
		html.classList.add(compareClassOpenHtml);

		if (swiper) {
			swiper.update();
		}

		localStorage.setItem(compareStorageKey, 'true');
	}

	function compareMenuClose() {
		if (isMobile && ww < 1024) {
			window.docEnableScroll && docEnableScroll();
		}

		open = false;
		compareMenu.classList.remove(compareClassOpen);
		html.classList.remove(compareClassOpenHtml);

		localStorage.setItem(compareStorageKey, 'false');
	}

	function compareMenuInit() {
		const compareMenuCloseEl = compareMenu.querySelectorAll('[data-close]');
		const compareMenuToggleEl = compareMenu.querySelectorAll('[data-toggle-menu]');

		// 檢測是否曾經有操作過比較介面
		const compareStorage = localStorage.getItem(compareStorageKey);
		if ((compareStorage === null && open) || compareStorage === 'true') {
			compareMenu.classList.add('is-open');
		}

		if (compareStorage !== null) {
			open = compareStorage === 'true';
		}

		compareMenuToggleEl.forEach((el) => {
			el.addEventListener('click', function() {
				if (!open) {
					compareMenuOpen();
				} else {
					compareMenuClose();
				}
			});
		});
	
		compareMenuCloseEl.forEach((el) => {
			el.addEventListener('click', compareMenuClose);
		});
	}
	/* ---------------------------------------- [END] 選單 - 展開收合  */

	/* ---------------------------------------- [START] Scroll Enabled  */
	// 因為開關會鎖 ScrollBar ，如果使用者 Resize 1024+ 就會造成無法 Scroll 問題
	const scrollBreakpoint = window.matchMedia('(min-width: 1024px)');
	const scrollBreakpointChecker = function() {
		if (scrollBreakpoint.matches) {
			// Large
			window.docEnableScroll && docEnableScroll();
		} else if (open) {
			window.docDisableScroll && docDisableScroll();
		}
	}
	window.addEventListener('load', function() {
		scrollBreakpointChecker();
		scrollBreakpoint.addListener(scrollBreakpointChecker);
	});
	/* ---------------------------------------- [END] Scroll Enabled  */

	/* ---------------------------------------- [START] 選單  */
	const pdCompareCarousel = '#pd-compare-carousel'; // .swiper-container id

	function compareMenuSwiperBuild() {
		const swiperTarget = pdCompareCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');

		const buildSwiper = function () {
			swiper = new Swiper(swiperTarget, {
				spaceBetween: 20,
				slidesPerView: 2,
				slidesPerGroup: 2,
				autoHeight: true,
				lazy: true,
				preloadImages: false,
				navigation: {
					nextEl: swiperNextEl,
					prevEl: swiperPrevEl,
				},
				breakpoints: {
					1200: {
						slidesPerView: 3,
						slidesPerGroup: 3,
					}
				},
				on: {
					init (sw) {
						// 一定要先update，不然剛進入頁面沒辦法移除
						setTimeout(() => {
							sw.update();
						}, 100);
					}
				}
			});
		}

		const compareMenuBreakpoint = window.matchMedia('(min-width: 1024px)');
		const compareMenuBreakpointChecker = function() {
			if (compareMenuBreakpoint.matches) {
				// Large
				buildSwiper();
			} else {
				// Small + Medium
				if (swiper !== undefined && swiper !== null) {
					swiper.destroy(true, true);
					swiper = null;
				}
			}
		}

		// Start
		compareMenuBreakpoint.addListener(compareMenuBreakpointChecker);
		compareMenuBreakpointChecker();
	}
	/* ---------------------------------------- [END] 選單 */

	/* ---------------------------------------- [START] Scroll */
	const footer = document.querySelector('#footer');
	const compareClassCollapseHtml = 'compare-collapse';

	function compareMenuScroll() {
		if (wh > footer.getBoundingClientRect().top) {
			// 滑動到 Footer 位置 => 固定
			compareMenu.classList.add(compareClassCollapse);
			html.classList.add(compareClassCollapseHtml);
		} else {
			compareMenu.classList.remove(compareClassCollapse);
			html.classList.remove(compareClassCollapseHtml);
		}
	}
	/* ---------------------------------------- [END] Scroll */

	/* ---------------------------------------- [START] 額外項目 */
	// 避免手機板鎖住
	const compareClear = document.querySelector('#compare-menu-clear'); // 全部清除
	if (compareClear) {
		compareClear.addEventListener('click', function() {
			if (isMobile && ww < 1024) {
				window.docEnableScroll && docEnableScroll();
			}
		});
	}
	/* ---------------------------------------- [END] 額外項目 */

	window.addEventListener('load', function() {
		if (compareMenu) {
			// Window setting
			getWinSet();
			window.addEventListener('resize', getWinSet);

			// Init
			compareMenuInit();
			compareMenuSwiperBuild();

			// Scroll Handler
			compareMenuScroll();
			window.addEventListener('scroll', compareMenuScroll);

			// 數量計算
			//- ※為了要讓後端可以更動，將JS移動到頁面 inline script 中
			// compareMenuCountInit();
		}
	});

})(window, document);



// /* ---------------------------------------- [START] 讀取+更換數量 */
// //- ※為了要讓後端可以更動，將JS移動到頁面 inline script 中
// (function(window, document) {
// 	const html = document.documentElement; // <html>
// 	const checkboxs = document.querySelectorAll('.js-compare-checkbox'); // 比較checkbox
// 	const compareMenu = document.querySelector('#compare-menu'); // 比較選單
// 	let compareArr = []; // 比較陣列
// 	let compareList = null; // 紀錄 <ul>
// 	const compareClassHide = 'hide'; // 比較選單隱藏class
// 	const compareClassHasCompareHtml = 'compare-show'; // 比較選單顯示class
// 	const compareWrapper = document.querySelector('#pd-compare-carousel'); // .swiper-container
// 	const compareSubmit = document.querySelector('#compare-menu-submit'); // 送出按鈕
// 	const compareSubmitNum = compareSubmit.querySelector('.num'); // 統計數字
// 	const compareClear = document.querySelector('#compare-menu-clear'); // 全部清除

// 	/* ------------------ [START] 讀取Swiper */
// 	//- 取得 Swiper 物件，在 compareWrapper 物件上
// 	let swiper = null;
// 	function getSwiper() {
// 		return (compareWrapper.swiper && !compareWrapper.swiper.destroyed) ? compareWrapper.swiper : null
// 	}
// 	//- 建立breakpoint，每當1024+、1023-轉換時啟動
// 	const swiperBreakpoint = window.matchMedia('(min-width: 1024px)');
// 	const swiperBreakpointChecker = function() {
// 		//- 延遲：等Swiper被破壞
// 		setTimeout(()=> {
// 			swiper = getSwiper();
// 		}, 500)
// 	}
// 	window.addEventListener('load', function() {
// 		//- 延遲：等Swiper被建立
// 		setTimeout(()=> {
// 			swiper = getSwiper();
// 		}, 500);
// 		//- START：Breakpoint
// 		swiperBreakpoint.addListener(swiperBreakpointChecker);
// 	});
// 	/* ------------------ [END] 讀取Swiper */

// 	//- Init
// 	function compareMenuCountInit() {
// 		const compareItems = compareWrapper.querySelectorAll('.compare-list__item'); // <li>

// 		//- 因為用 Swiper 建立相關物件，所以一開始會記錄到錯誤物件
// 		compareList = compareWrapper.querySelector('.compare-list'); // <ul>

// 		// 比較列表項目
// 		compareItems.forEach((el, index) => {
// 			const id = el.dataset['id']; // 取得對應的 id
// 			const checkbox = document.querySelector(`#${id}`); // 找到相對應的 checkbox 項目

// 			compareArr.push({
// 				id,
// 				el,
// 				checkbox
// 			});
			
// 			if (checkbox) {
// 				// 項目給予 checked 狀態
// 				checkbox.checked = true;
// 			}

// 			const del = el.querySelector('.del');
// 			del.addEventListener('click', delHandler);
			
// 		});

// 		compareUpdate(); // 數量更新

// 		// =======================================

// 		// Checkbox 事件
// 		checkboxs.forEach((checkbox) => {

// 			checkbox.addEventListener('click', function(event) {
// 				const _this = this;
// 				if (compareArr.length >= 6 && _this.checked) {
// 					// 數量超過6個
// 					event.preventDefault();
// 					return $('#popup-compare-alert').foundation('open'); // 開啟警示通知
// 				} else if (_this.checked) {
// 					// 第一次增加
// 					if (!_this.compareData) {
// 						let data = _this.getAttribute('data-value');

// 						const $parent = $(_this).parents('.pd-list__item');
// 						const $link = $parent.find('.pd-list__link');
// 						const $img = $parent.find('.pd-list__img');

// 						if (data) {
// 							data = JSON.parse(data);
// 						} else {
// 							data = {
// 								id: _this.id,
// 								value: $(this).attr('value'), // <input type="hidden"> value
// 								href: $link.attr('href'),
// 								title: $link.attr('title'), // <a> title
// 								name: $parent.find('.pd-list__name').text(),
// 								price: $parent.find('.pd-list__price__num').text(),
// 								img: $img.attr('data-src') || $img.attr('src'),
// 							}
// 						}
// 						checkbox.compareData = data;
// 					}

// 					// 增加
// 					compareAdd(_this.compareData);
// 				} else {
// 					// 移除
// 					compareRemove(_this.id);
// 				}
// 			});
// 		});

// 		// =======================================

// 		// Clear All
// 		compareClear.addEventListener('click', function() {
// 			compareArr.forEach(data => {
// 				compareRemove(data.id, false, false);
// 			});

// 			if (swiper) {
// 				while (swiper.slides.length > 0) {
// 					swiper.removeSlide(swiper.realIndex);
// 				}
// 			} else {
// 				compareList.innerHTML = '';
// 			}

// 			// 最後統一清空陣列
// 			compareArr = [];

// 			// 更新數量
// 			compareUpdate();
// 		});

// 	}

// 	//- 刪除事件
// 	function delHandler() {
// 		const parent = this.parentElement;
// 		const id = parent.dataset['id'];

// 		compareRemove(id);
// 	}

// 	// =======================================

// 	// Compare 事件

// 	function compareUpdate() {
// 		// 判斷是否隱藏選單
// 		if (compareArr.length === 0) {
// 			compareMenu.classList.add(compareClassHide);
// 			html.classList.remove(compareClassHasCompareHtml);
// 			window.docEnableScroll && docEnableScroll();
// 		} else {
// 			html.classList.add(compareClassHasCompareHtml);
// 			compareMenu.classList.remove(compareClassHide);
// 		}

// 		// 更改按鈕狀態
// 		if (compareArr.length < 2) {
// 			compareSubmit.setAttribute('disabled', '');
// 		} else {
// 			compareSubmit.removeAttribute('disabled');
// 		}

// 		// 顯示數量
// 		compareSubmitNum.innerText = compareArr.length;
// 	}

// 	const tmpParent = document.querySelector('#compare-item-tmp');
// 	const tmp = tmpParent.querySelector('li').cloneNode(true);
// 	tmpParent.remove(); // 移除物件

// 	/**
// 	* 增加 Compare 物件
// 	* @param {object} data - 帶入資料
// 	*/
// 	function compareAdd(data) {
// 		const el = tmp.cloneNode(true);

// 		// // 取得值
// 		// const data = {
// 		// 	id: id,
// 		// 	value: '', // <input type="hidden"> value
// 		// 	href: '',
// 		// 	title: '', // <a> title
// 		// 	name: '',
// 		// 	price: '',
// 		// 	img: '',
// 		// }

// 		// 設定值
// 		el.setAttribute('data-id', data.id);
// 		el.querySelector('input').value = data.value;

// 		const link = el.querySelector('.compare-list__link');
// 		link.setAttribute('href', data.href);
// 		link.setAttribute('title', data.title);

// 		el.querySelector('.compare-list__name').innerText = data.name;
// 		el.querySelector('.compare-list__price').innerText = data.price;
// 		el.querySelector('.compare-list__img').setAttribute('src', data.img);
// 		el.querySelector('.del').addEventListener('click', delHandler);

// 		// Add DOM
// 		if (swiper) {
// 			// 有 Swiper 的情況
// 			swiper.appendSlide(el);
// 		} else {
// 			compareList.appendChild(el);
// 		}

// 		// 更新陣列資料
// 		compareArr.push({
// 			id: data.id,
// 			el,
// 			checkbox: document.querySelector(`#${data.id}`) // 找到相對應的 checkbox 項目
// 		});

// 		// 更新數量
// 		compareUpdate();
// 	}

// 	/**
// 	* 移除 Compare 物件
// 	* @param {string} id - 帶入 <input type="checkbox"> id
// 	* @param {boolean} removeDOM - 是否移除比較DOM（Clear All Swiper 會出問題），預設 true
// 	* @param {boolean} updateData - 是否更改數值（移除陣列、更改數量），預設 true
// 	*/
// 	function compareRemove(id, removeDOM = true, updateData = true) {
// 		const index = compareFindIndex(id); // 取得 Index
// 		const data = compareArr[index]; // 取得資料

// 		// 取消 Checkbox
// 		data.checkbox && (data.checkbox.checked = false);

// 		// Remove DOM
// 		if (removeDOM) {
// 			if (swiper) {
// 				// 有 Swiper 的情況
// 				swiper.removeSlide(index);
// 			} else {
// 				data.el.remove();
// 			}
// 		}

// 		if (updateData) {
// 			// 移除 Array 紀錄
// 			compareArr.splice(index, 1);
	
// 			// 更新數量
// 			compareUpdate();
// 		}

// 	}

// 	function compareFindIndex(id) {
// 		return compareArr.findIndex(val => val.id === id);
// 	}
	

// 	//- START
// 	window.addEventListener('load', function() {
// 		if (compareMenu) {
// 			// 數量計算
// 			//- ※因為同步資料由後端處理，移除前端寫法需要的東西
// 			compareMenuCountInit();
// 		}
// 	});
// })(window, document);
// /* ---------------------------------------- [END] 讀取+更換數量 */
